// pages/pages-routing.module.ts
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PagesComponent } from './pages.component';
import { SourcingDiscoveryComponent } from './sourcing-discovery/sourcing-discovery.component';
import { CountryselectionComponent } from './countryselection/countryselection.component';
import { AuthGuardService } from './auth.guard';
import { ProductViewComponent } from './product-view/product-view.component';
import { NoResultFoundComponent } from './no-result-found/no-result-found.component';
import { ProductSourcingDetailComponent } from './product-sourcing-detail/product-sourcing-detail.component';
import { SupplierDetailComponent } from './supplier-detail/supplier-detail.component';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { NoDataFoundComponent } from './no-data-found/no-data-found.component';
import { ProductVarientComponent } from './product-varient/product-varient.component';
import { CompanyPrductGroupComponent } from './company-prduct-group/company-prduct-group.component';

 
const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', loadChildren: () => import('./login/login.module').then(m => m.LoginModule),data: { title: 'CIS | Login' } },
  {
    path: '',
    component: PagesComponent,
    children: [

      { path: 'category-discovery', component: SourcingDiscoveryComponent,data:{title:'CIS | Home'}},
      { path: 'country', component: CountryselectionComponent ,data: { title: 'CIS | Country-Login' } },
      { path: 'product-discovery', component: ProductViewComponent ,data: { title: 'CIS | Product-List' } },
      { path: 'no-result-found', component: NoResultFoundComponent,data: { title: 'CIS | No-Result-Found' }  },
      { path: 'supplier-details', component: SupplierDetailComponent,data: { title: 'CIS | Supp-Transaction' } },
      { path: 'supplier-discovery', component: ProductSourcingDetailComponent ,data: { title: 'CIS | Supplier-List' } },
      { path: 'product-detail', component: ProductDetailComponent ,data: { title: 'CIS | PDP' } },
      { path: 'no-data-found', component: NoDataFoundComponent,data: { title: 'CIS | No-Data-Found' }  },
      { path: 'product-varient', component:  ProductVarientComponent ,data: { title: 'CIS | Product Varients' } },
      { path: 'company-product-group', component:  CompanyPrductGroupComponent ,data: { title: 'CIS | Product Group' } },

    ],
    canActivate: [AuthGuardService],
    runGuardsAndResolvers: 'always'
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule { }
